import TermsAndConditionsService from "../../../../services/terms-and-conditions-service";

export type State = {
  message: string;
  success: boolean;
  defaultValues: { content: string };
};

const termsAndConditionsService = new TermsAndConditionsService();

export async function saveTermsAndConditions(
  prevState: State,
  formData: FormData
): Promise<State> {
  const data = {
    content: (formData.get("content") as string) ?? "",
  };

  try {
    const result = await termsAndConditionsService.saveTermsAndConditions(data);
    if (result.status === 200) {
      return {
        message: "Terms and conditions saved successfully.",
        success: true,
        defaultValues: data,
      };
    }
  } catch (error) {
    console.log(error);
  }

  return {
    message: "Error saving terms and conditions.",
    success: false,
    defaultValues: data,
  };
}
